import { AnimatePresence, motion } from 'framer-motion';
import React, { type ComponentProps, useState } from 'react';

import { cn } from '@/clientOnlyUtils/cn';

import styles from './DetailPage.module.scss';

type DetailPageProps = ComponentProps<'div'> & {
  initiallyAnimate?: boolean;
  detailSize?: 'small';
};

export const DetailPage = ({ children, initiallyAnimate, detailSize }: DetailPageProps) => {
  const [wasOpenedInitially, setWasOpenedInitially] = useState(false);

  return (
    <AnimatePresence>
      <motion.div
        className={cn(
          'absolute bottom-0 right-0 top-0 flex h-full flex-col items-stretch',
          styles.container,
          detailSize ? styles[detailSize] : undefined,
        )}
        initial={initiallyAnimate && !wasOpenedInitially ? undefined : { opacity: 0.2, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        onAnimationStart={() => {
          if (initiallyAnimate && !wasOpenedInitially) {
            setWasOpenedInitially(true);
          }
        }}
        transition={{ type: 'spring' }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
